import { useEffect } from 'react';
import { authUtils } from '../../utils/authUtils';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { authAtom } from '../../_state';

const DidasRoute = ({ children }) => {
  const { key } = useParams();
  let navigate = useNavigate();

  const [auth, setAuth] = useRecoilState(authAtom);
  const setLocalStorage = (data) => {
    localStorage.setItem('user', JSON.stringify(data));
  };

  useEffect(async () => {
    await authUtils
      .useIsDidas(key)
      .then((result) => {
        if (!result.data.success) {
          alert('DIDAS에서 접근이 아닙니다.');
          navigate('/');
        } else {
          setLocalStorage(result.data.userInfo);
          setAuth(result.data.userInfo);
        }
      })
      .catch((e) => {
        alert('DIDAS에서 접근이 아닙니다.');
        navigate('/');
      });
  }, []);

  return children;
};

export default DidasRoute;
